import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PageRequest, SpringPage } from '../../page';
import { NgIf } from '@angular/common';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { TranslatePipe } from '@ngx-translate/core';
import * as pager from '@shared/pager';

@Component({
  selector: 'app-table-pager',
  templateUrl: './table-pager.component.html',
  styleUrl: './table-pager.component.scss',
  imports: [NgIf, NgxDatatableModule, TranslatePipe],
})
export class TablePagerComponent {
  @Input() data: SpringPage<any>;
  @Input() page: PageRequest;
  @Output() changePage = new EventEmitter<number>();
  protected readonly pager = pager;
}
